import { defineMessages } from 'react-intl';
export default defineMessages({
  customSchema: {
    id: 'component.metadataForm.customSchema',
    defaultMessage: 'Custom Schema',
  },
});
